var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 999.996,
    height: 999.996,
    viewBox: "0 0 1670 1670",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7eb128;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "WS-LOGO\\u7EFF\\u5E95",
    className: "cls-1",
    d: "M968,3532c-461.71,0-836-374.29-836-836V1862H966c461.71,0,836,374.29,836,836v834H968Zm112.64-589.13,95.26-225.72-10.77-25.66-94.83,224.7Zm-16.62-42.89,94.56-224.07-9.96-23.73-94.16,223.12Zm-15.85-40.89,93.9-222.49L1133,2615l-93,223ZM1219,2094L969,2365h58L890,2688,787,2413H654l-93,260-88-259H255l212,633H589l115-330,121,330H931l251-616,37,32V2094Zm249,319H1352l-156,352-13.55-32.27-95.52,226.35L1121,3047h148l145-330,78,149-89,206-51-43v333l238-204-48-17,143-283Z",
    transform: "translate(-132 -1862)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveshare);
export default __webpack_public_path__ + "static/media/waveshare.30c6fd2039e471879f59ece74ab6c9f6.svg";
export { ForwardRef as ReactComponent };